/* ==========================================================================
   LANDING VIEW CONTROLLER (ts/views/landing.ts)
   ========================================================================== */

export function initLandingView(): void {
  // 1. Sticky Header Scroll Effect
  const header = document.querySelector<HTMLElement>('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // 2. Use-Case Tab Switcher
  const tabButtons = document.querySelectorAll<HTMLButtonElement>('.tab-btn');
  const tabContents = document.querySelectorAll<HTMLElement>('.tab-content');

  tabButtons.forEach((button: HTMLButtonElement) => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');

      tabButtons.forEach((btn) => {
        btn.classList.remove('active');
      });
      tabContents.forEach((content) => {
        content.classList.remove('active');
      });

      button.classList.add('active');
      if (targetTab) {
        const activeContent = document.getElementById(targetTab);
        if (activeContent) {
          activeContent.classList.add('active');
        }
      }
    });
  });

  // 3. FAQ Accordion Toggle
  const faqItems = document.querySelectorAll<HTMLElement>('.faq-item');

  faqItems.forEach((item: HTMLElement) => {
    const question = item.querySelector<HTMLElement>('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        faqItems.forEach((i) => {
          i.classList.remove('open');
        });

        if (!isOpen) {
          item.classList.add('open');
        }
      });
    }
  });
}
